module.exports = __webpack_public_path__ + "assets/img/23.647b3400.png";